import { Directive, ElementRef, Input, OnInit, Renderer2, inject } from '@angular/core';

@Directive( {
  selector: '[appSuffix]',
  standalone: true
} )
export class SuffixDirective implements OnInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  @Input() suffix: string;

  ngOnInit() {
    const suffixEl = this.renderer.createElement( 'span' );
    this.renderer.appendChild( suffixEl, this.renderer.createText( this.suffix ) );
    this.renderer.setStyle( suffixEl, 'position', 'absolute' );
    this.renderer.setStyle( suffixEl, 'right', '4px' );
    this.renderer.setStyle( suffixEl, 'top', '50%' );
    this.renderer.setStyle( suffixEl, 'transform', 'translateY(-50%)' );

    const parentNodeEl = this.renderer.parentNode( this.el.nativeElement );
    this.renderer.setStyle( parentNodeEl, 'position', 'relative' );

    this.renderer.setStyle( this.el.nativeElement, 'paddingRight', '4px' );
    this.renderer.addClass( this.el.nativeElement, 'css-suffix' );
    this.renderer.appendChild( parentNodeEl, suffixEl );
  }
}
